{
 "code": "SA456",
 "edition": "SA456.2511",
 "pageSize": [
  595.28,
  841.89
 ],
 "source": "https://www.servicesaustralia.gov.au/sa456",
 "fields": {
  "q1_option1": {
   "kind": "tick",
   "page": 6,
   "boxes": [
    [
     128.3,
     255.1,
     139.3,
     266.2
    ]
   ]
  },
  "q2_no": {
   "kind": "tick",
   "page": 6,
   "boxes": [
    [
     65.3,
     635.1,
     76.4,
     646.2
    ]
   ]
  },
  "q3_no": {
   "kind": "tick",
   "page": 6,
   "boxes": [
    [
     348.8,
     154.6,
     359.9,
     165.7
    ]
   ]
  },
  "q3_yes": {
   "kind": "tick",
   "page": 6,
   "boxes": [
    [
     348.8,
     173.0,
     359.9,
     184.1
    ]
   ]
  },
  "q3_name": {
   "kind": "text",
   "page": 6,
   "boxes": [
    [
     331.8,
     202.8,
     566.8,
     242.2
    ]
   ]
  },
  "q3_relationship": {
   "kind": "text",
   "page": 6,
   "boxes": [
    [
     331.8,
     259.5,
     566.8,
     279.1
    ]
   ]
  },
  "q4_no": {
   "kind": "tick",
   "page": 6,
   "boxes": [
    [
     348.8,
     555.7,
     359.9,
     566.8
    ]
   ]
  },
  "q4_yes": {
   "kind": "tick",
   "page": 6,
   "boxes": [
    [
     348.8,
     574.1,
     359.9,
     585.2
    ]
   ]
  },
  "q5_na": {
   "kind": "tick",
   "page": 7,
   "boxes": [
    [
     110.7,
     156.0,
     121.8,
     167.1
    ]
   ]
  },
  "q7_you_family": {
   "kind": "text",
   "page": 7,
   "boxes": [
    [
     48.3,
     508.9,
     283.3,
     528.5
    ]
   ]
  },
  "q7_you_first": {
   "kind": "text",
   "page": 7,
   "boxes": [
    [
     48.3,
     544.4,
     283.3,
     564.0
    ]
   ]
  },
  "q8_you_dob": {
   "kind": "date",
   "page": 7,
   "boxes": [
    [
     48.3,
     632.3,
     76.7,
     652.1
    ],
    [
     82.3,
     632.3,
     110.7,
     652.1
    ],
    [
     116.3,
     632.3,
     173.0,
     652.1
    ]
   ]
  },
  "q9_you_male": {
   "kind": "tick",
   "page": 7,
   "boxes": [
    [
     96.5,
     687.5,
     107.6,
     698.6
    ]
   ]
  },
  "q9_you_female": {
   "kind": "tick",
   "page": 7,
   "boxes": [
    [
     96.5,
     703.1,
     107.6,
     714.2
    ]
   ]
  },
  "q11_you_phone": {
   "kind": "comb",
   "page": 8,
   "boxes": [
    [
     48.3,
     545.8,
     190.0,
     565.6
    ]
   ],
   "cells": 10
  },
  "q11_you_email": {
   "kind": "text",
   "page": 8,
   "boxes": [
    [
     48.3,
     582.6,
     283.3,
     602.2
    ]
   ]
  },
  "q7_partner_family": {
   "kind": "text",
   "page": 7,
   "boxes": [
    [
     331.8,
     508.9,
     566.8,
     528.5
    ]
   ]
  },
  "q7_partner_first": {
   "kind": "text",
   "page": 7,
   "boxes": [
    [
     331.8,
     544.4,
     566.8,
     564.0
    ]
   ]
  },
  "q8_partner_dob": {
   "kind": "date",
   "page": 7,
   "boxes": [
    [
     331.8,
     632.3,
     360.1,
     652.1
    ],
    [
     365.8,
     632.3,
     394.1,
     652.1
    ],
    [
     399.8,
     632.3,
     456.5,
     652.1
    ]
   ]
  },
  "q9_partner_male": {
   "kind": "tick",
   "page": 7,
   "boxes": [
    [
     380.0,
     687.5,
     391.1,
     698.6
    ]
   ]
  },
  "q9_partner_female": {
   "kind": "tick",
   "page": 7,
   "boxes": [
    [
     380.0,
     703.1,
     391.1,
     714.2
    ]
   ]
  },
  "q11_partner_phone": {
   "kind": "comb",
   "page": 8,
   "boxes": [
    [
     331.8,
     545.8,
     473.5,
     565.6
    ]
   ],
   "cells": 10
  },
  "q11_partner_email": {
   "kind": "text",
   "page": 8,
   "boxes": [
    [
     331.8,
     582.6,
     566.8,
     602.2
    ]
   ]
  },
  "q15_yes": {
   "kind": "tick",
   "page": 9,
   "boxes": [
    [
     65.3,
     499.0,
     76.4,
     510.1
    ]
   ]
  },
  "q17_no": {
   "kind": "tick",
   "page": 10,
   "boxes": [
    [
     65.3,
     88.0,
     76.4,
     99.1
    ]
   ]
  },
  "q17_yes": {
   "kind": "tick",
   "page": 10,
   "boxes": [
    [
     65.3,
     106.4,
     76.4,
     117.5
    ]
   ]
  },
  "q18_no": {
   "kind": "tick",
   "page": 10,
   "boxes": [
    [
     65.3,
     354.5,
     76.4,
     365.5
    ]
   ]
  },
  "q18_yes": {
   "kind": "tick",
   "page": 10,
   "boxes": [
    [
     65.3,
     372.9,
     76.4,
     384.0
    ]
   ]
  },
  "q19_no": {
   "kind": "tick",
   "page": 10,
   "boxes": [
    [
     65.5,
     445.2,
     76.6,
     456.3
    ]
   ]
  },
  "q20_no": {
   "kind": "tick",
   "page": 10,
   "boxes": [
    [
     348.9,
     59.7,
     360.0,
     70.7
    ]
   ]
  },
  "q20_yes": {
   "kind": "tick",
   "page": 10,
   "boxes": [
    [
     348.9,
     75.2,
     360.0,
     86.3
    ]
   ]
  },
  "q27_no": {
   "kind": "tick",
   "page": 12,
   "boxes": [
    [
     65.3,
     100.8,
     76.4,
     111.8
    ]
   ]
  },
  "q27_yes": {
   "kind": "tick",
   "page": 12,
   "boxes": [
    [
     65.3,
     119.2,
     76.4,
     130.3
    ]
   ]
  },
  "q28_count": {
   "kind": "text",
   "page": 12,
   "boxes": [
    [
     48.5,
     191.5,
     172.9,
     211.1
    ]
   ]
  },
  "q31_you": {
   "kind": "tick",
   "page": 12,
   "boxes": [
    [
     385.6,
     61.1,
     396.7,
     72.2
    ]
   ]
  },
  "q31_partner": {
   "kind": "tick",
   "page": 12,
   "boxes": [
    [
     385.6,
     85.2,
     396.7,
     96.3
    ]
   ]
  },
  "q31_share_you": {
   "kind": "text",
   "page": 12,
   "boxes": [
    [
     487.7,
     56.8,
     566.8,
     76.4
    ]
   ]
  },
  "q31_share_partner": {
   "kind": "text",
   "page": 12,
   "boxes": [
    [
     487.7,
     80.9,
     566.8,
     100.5
    ]
   ]
  },
  "q32_no": {
   "kind": "tick",
   "page": 12,
   "boxes": [
    [
     348.8,
     326.1,
     359.9,
     337.2
    ]
   ]
  },
  "q32_yes": {
   "kind": "tick",
   "page": 12,
   "boxes": [
    [
     348.8,
     344.5,
     359.9,
     355.6
    ]
   ]
  },
  "q34_value": {
   "kind": "text",
   "page": 13,
   "boxes": [
    [
     52.6,
     133.4,
     165.7,
     152.9
    ]
   ],
   "padLeft": 12.2
  },
  "q37_no": {
   "kind": "tick",
   "page": 13,
   "boxes": [
    [
     348.9,
     646.4,
     360.0,
     657.5
    ]
   ]
  },
  "q37_yes": {
   "kind": "tick",
   "page": 13,
   "boxes": [
    [
     348.9,
     666.3,
     360.0,
     677.4
    ]
   ]
  },
  "q39_1_name": {
   "kind": "text",
   "page": 14,
   "boxes": [
    [
     336.0,
     477.8,
     562.6,
     497.4
    ]
   ]
  },
  "q39_1_type": {
   "kind": "text",
   "page": 14,
   "boxes": [
    [
     336.0,
     550.0,
     562.6,
     569.6
    ]
   ]
  },
  "q39_1_balance": {
   "kind": "text",
   "page": 14,
   "boxes": [
    [
     336.0,
     586.9,
     449.2,
     606.5
    ]
   ]
  },
  "q39_1_share_you": {
   "kind": "text",
   "page": 14,
   "boxes": [
    [
     406.9,
     612.4,
     449.2,
     632.0
    ]
   ]
  },
  "q39_1_share_partner": {
   "kind": "text",
   "page": 14,
   "boxes": [
    [
     520.3,
     612.4,
     562.6,
     632.0
    ]
   ]
  },
  "q39_2_name": {
   "kind": "text",
   "page": 15,
   "boxes": [
    [
     52.6,
     62.5,
     279.1,
     82.1
    ]
   ]
  },
  "q39_2_type": {
   "kind": "text",
   "page": 15,
   "boxes": [
    [
     52.6,
     134.8,
     279.1,
     154.4
    ]
   ]
  },
  "q39_2_balance": {
   "kind": "text",
   "page": 15,
   "boxes": [
    [
     52.6,
     171.6,
     165.7,
     191.2
    ]
   ]
  },
  "q39_2_share_you": {
   "kind": "text",
   "page": 15,
   "boxes": [
    [
     123.4,
     197.1,
     165.7,
     216.7
    ]
   ]
  },
  "q39_2_share_partner": {
   "kind": "text",
   "page": 15,
   "boxes": [
    [
     236.8,
     197.1,
     279.1,
     216.7
    ]
   ]
  },
  "q39_3_name": {
   "kind": "text",
   "page": 15,
   "boxes": [
    [
     52.6,
     246.7,
     279.1,
     266.3
    ]
   ]
  },
  "q39_3_type": {
   "kind": "text",
   "page": 15,
   "boxes": [
    [
     52.6,
     319.0,
     279.1,
     338.6
    ]
   ]
  },
  "q39_3_balance": {
   "kind": "text",
   "page": 15,
   "boxes": [
    [
     52.6,
     355.9,
     165.7,
     375.5
    ]
   ]
  },
  "q39_3_share_you": {
   "kind": "text",
   "page": 15,
   "boxes": [
    [
     123.4,
     381.4,
     165.7,
     401.0
    ]
   ]
  },
  "q39_3_share_partner": {
   "kind": "text",
   "page": 15,
   "boxes": [
    [
     236.8,
     381.4,
     279.1,
     401.0
    ]
   ]
  },
  "q39_4_name": {
   "kind": "text",
   "page": 15,
   "boxes": [
    [
     52.6,
     429.6,
     279.1,
     449.2
    ]
   ]
  },
  "q39_4_type": {
   "kind": "text",
   "page": 15,
   "boxes": [
    [
     52.6,
     501.9,
     279.1,
     521.5
    ]
   ]
  },
  "q39_4_balance": {
   "kind": "text",
   "page": 15,
   "boxes": [
    [
     52.6,
     538.7,
     165.7,
     558.3
    ]
   ]
  },
  "q39_4_share_you": {
   "kind": "text",
   "page": 15,
   "boxes": [
    [
     123.4,
     564.2,
     165.7,
     583.8
    ]
   ]
  },
  "q39_4_share_partner": {
   "kind": "text",
   "page": 15,
   "boxes": [
    [
     236.8,
     564.2,
     279.1,
     583.8
    ]
   ]
  },
  "q40_no": {
   "kind": "tick",
   "page": 15,
   "boxes": [
    [
     348.8,
     416.8,
     359.9,
     427.9
    ]
   ]
  },
  "q40_yes": {
   "kind": "tick",
   "page": 15,
   "boxes": [
    [
     348.8,
     435.2,
     359.9,
     446.3
    ]
   ]
  },
  "q40_1_institution": {
   "kind": "text",
   "page": 16,
   "boxes": [
    [
     52.6,
     58.1,
     279.1,
     77.7
    ]
   ]
  },
  "q40_1_fund": {
   "kind": "text",
   "page": 16,
   "boxes": [
    [
     52.6,
     95.1,
     279.1,
     114.7
    ]
   ]
  },
  "q40_1_balance": {
   "kind": "text",
   "page": 16,
   "boxes": [
    [
     52.6,
     156.0,
     157.2,
     175.6
    ]
   ],
   "padLeft": 11.9
  },
  "q40_1_income": {
   "kind": "text",
   "page": 16,
   "boxes": [
    [
     52.6,
     205.6,
     162.9,
     225.2
    ]
   ],
   "padLeft": 11.9
  },
  "q40_1_often": {
   "kind": "text",
   "page": 16,
   "boxes": [
    [
     168.8,
     205.6,
     279.1,
     225.2
    ]
   ],
   "padLeft": 19.9
  },
  "q40_1_share_you": {
   "kind": "text",
   "page": 16,
   "boxes": [
    [
     190.0,
     251.0,
     232.3,
     270.6
    ]
   ]
  },
  "q40_1_share_partner": {
   "kind": "text",
   "page": 16,
   "boxes": [
    [
     236.8,
     251.0,
     279.1,
     270.6
    ]
   ]
  },
  "q40_2_institution": {
   "kind": "text",
   "page": 16,
   "boxes": [
    [
     52.6,
     296.2,
     279.1,
     315.8
    ]
   ]
  },
  "q40_2_fund": {
   "kind": "text",
   "page": 16,
   "boxes": [
    [
     52.6,
     333.2,
     279.1,
     352.8
    ]
   ]
  },
  "q40_2_balance": {
   "kind": "text",
   "page": 16,
   "boxes": [
    [
     52.6,
     394.1,
     157.2,
     413.7
    ]
   ],
   "padLeft": 11.9
  },
  "q40_2_income": {
   "kind": "text",
   "page": 16,
   "boxes": [
    [
     52.6,
     443.7,
     162.9,
     463.3
    ]
   ],
   "padLeft": 11.9
  },
  "q40_2_often": {
   "kind": "text",
   "page": 16,
   "boxes": [
    [
     168.8,
     443.7,
     279.1,
     463.3
    ]
   ],
   "padLeft": 19.9
  },
  "q40_2_share_you": {
   "kind": "text",
   "page": 16,
   "boxes": [
    [
     190.0,
     489.1,
     232.3,
     508.7
    ]
   ]
  },
  "q40_2_share_partner": {
   "kind": "text",
   "page": 16,
   "boxes": [
    [
     236.8,
     489.1,
     279.1,
     508.7
    ]
   ]
  },
  "q41_no": {
   "kind": "tick",
   "page": 16,
   "boxes": [
    [
     348.8,
     283.6,
     359.9,
     294.7
    ]
   ]
  },
  "q42_no": {
   "kind": "tick",
   "page": 17,
   "boxes": [
    [
     65.3,
     246.7,
     76.4,
     257.8
    ]
   ]
  },
  "q42_yes": {
   "kind": "tick",
   "page": 17,
   "boxes": [
    [
     65.3,
     265.2,
     76.4,
     276.3
    ]
   ]
  },
  "q42_1_company": {
   "kind": "text",
   "page": 17,
   "boxes": [
    [
     52.6,
     337.4,
     279.1,
     357.0
    ]
   ]
  },
  "q42_1_share_you": {
   "kind": "text",
   "page": 17,
   "boxes": [
    [
     168.8,
     440.9,
     219.6,
     460.5
    ]
   ]
  },
  "q42_1_share_partner": {
   "kind": "text",
   "page": 17,
   "boxes": [
    [
     226.9,
     440.9,
     277.7,
     460.5
    ]
   ]
  },
  "q42_2_company": {
   "kind": "text",
   "page": 17,
   "boxes": [
    [
     52.6,
     487.7,
     279.1,
     507.3
    ]
   ]
  },
  "q42_2_share_you": {
   "kind": "text",
   "page": 17,
   "boxes": [
    [
     168.8,
     568.5,
     219.6,
     588.1
    ]
   ]
  },
  "q42_2_share_partner": {
   "kind": "text",
   "page": 17,
   "boxes": [
    [
     226.9,
     568.5,
     277.7,
     588.1
    ]
   ]
  },
  "q43_no": {
   "kind": "tick",
   "page": 17,
   "boxes": [
    [
     348.8,
     244.4,
     359.9,
     255.5
    ]
   ]
  },
  "q44_no": {
   "kind": "tick",
   "page": 18,
   "boxes": [
    [
     65.3,
     85.2,
     76.4,
     96.3
    ]
   ]
  },
  "q44_yes": {
   "kind": "tick",
   "page": 18,
   "boxes": [
    [
     65.3,
     103.6,
     76.4,
     114.7
    ]
   ]
  },
  "q44_1_company": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     52.4,
     187.1,
     278.7,
     206.7
    ]
   ]
  },
  "q44_1_value": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     52.0,
     324.0,
     164.3,
     343.6
    ]
   ],
   "padLeft": 12.0
  },
  "q44_1_share_you": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     168.7,
     324.0,
     219.5,
     343.6
    ]
   ]
  },
  "q44_1_share_partner": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     226.6,
     324.0,
     277.4,
     343.6
    ]
   ]
  },
  "q44_2_company": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     52.4,
     368.5,
     278.7,
     388.1
    ]
   ]
  },
  "q44_2_value": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     52.0,
     505.5,
     164.3,
     525.1
    ]
   ],
   "padLeft": 12.0
  },
  "q44_2_share_you": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     168.7,
     505.5,
     219.5,
     525.1
    ]
   ]
  },
  "q44_2_share_partner": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     226.6,
     505.5,
     277.4,
     525.1
    ]
   ]
  },
  "q45_no": {
   "kind": "tick",
   "page": 18,
   "boxes": [
    [
     348.8,
     71.0,
     359.9,
     82.1
    ]
   ]
  },
  "q45_yes": {
   "kind": "tick",
   "page": 18,
   "boxes": [
    [
     348.8,
     89.4,
     359.9,
     100.5
    ]
   ]
  },
  "q45_1_product": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     336.0,
     163.1,
     562.6,
     182.7
    ]
   ]
  },
  "q45_1_share_you": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     453.7,
     246.7,
     504.4,
     266.3
    ]
   ]
  },
  "q45_1_share_partner": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     511.8,
     247.0,
     562.6,
     266.6
    ]
   ]
  },
  "q45_2_product": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     336.0,
     292.1,
     562.6,
     311.7
    ]
   ]
  },
  "q45_2_share_you": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     453.7,
     375.7,
     504.4,
     395.3
    ]
   ]
  },
  "q45_2_share_partner": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     511.8,
     376.0,
     562.6,
     395.6
    ]
   ]
  },
  "q47_no": {
   "kind": "tick",
   "page": 19,
   "boxes": [
    [
     348.8,
     448.0,
     359.9,
     459.1
    ]
   ]
  },
  "q47_yes": {
   "kind": "tick",
   "page": 19,
   "boxes": [
    [
     348.8,
     466.4,
     359.9,
     477.5
    ]
   ]
  },
  "q46_no": {
   "kind": "tick",
   "page": 19,
   "boxes": [
    [
     65.3,
     122.0,
     76.4,
     133.1
    ]
   ]
  },
  "q46_yes": {
   "kind": "tick",
   "page": 19,
   "boxes": [
    [
     65.3,
     140.4,
     76.4,
     151.5
    ]
   ]
  },
  "q46_1_who": {
   "kind": "text",
   "page": 19,
   "boxes": [
    [
     52.3,
     276.5,
     278.9,
     296.1
    ]
   ]
  },
  "q46_1_date": {
   "kind": "date",
   "page": 19,
   "boxes": [
    [
     52.6,
     313.4,
     80.9,
     333.2
    ],
    [
     86.6,
     313.4,
     114.9,
     333.2
    ],
    [
     120.6,
     313.4,
     177.3,
     333.2
    ]
   ]
  },
  "q46_1_amount": {
   "kind": "text",
   "page": 19,
   "boxes": [
    [
     52.6,
     351.6,
     162.9,
     371.2
    ]
   ],
   "padLeft": 11.9
  },
  "q46_1_balance": {
   "kind": "text",
   "page": 19,
   "boxes": [
    [
     168.8,
     351.5,
     279.1,
     371.1
    ]
   ],
   "padLeft": 12.0
  },
  "q46_1_share_you": {
   "kind": "text",
   "page": 19,
   "boxes": [
    [
     112.1,
     378.6,
     162.9,
     398.1
    ]
   ]
  },
  "q46_1_share_partner": {
   "kind": "text",
   "page": 19,
   "boxes": [
    [
     228.3,
     378.6,
     279.1,
     398.1
    ]
   ]
  },
  "q46_2_who": {
   "kind": "text",
   "page": 19,
   "boxes": [
    [
     52.3,
     423.9,
     278.9,
     443.5
    ]
   ]
  },
  "q46_2_date": {
   "kind": "date",
   "page": 19,
   "boxes": [
    [
     52.6,
     460.8,
     80.9,
     480.6
    ],
    [
     86.6,
     460.8,
     114.9,
     480.6
    ],
    [
     120.6,
     460.8,
     177.3,
     480.6
    ]
   ]
  },
  "q46_2_amount": {
   "kind": "text",
   "page": 19,
   "boxes": [
    [
     52.6,
     499.0,
     162.9,
     518.6
    ]
   ],
   "padLeft": 11.9
  },
  "q46_2_balance": {
   "kind": "text",
   "page": 19,
   "boxes": [
    [
     168.8,
     498.9,
     279.1,
     518.5
    ]
   ],
   "padLeft": 11.9
  },
  "q46_2_share_you": {
   "kind": "text",
   "page": 19,
   "boxes": [
    [
     112.1,
     526.0,
     162.9,
     545.5
    ]
   ]
  },
  "q46_2_share_partner": {
   "kind": "text",
   "page": 19,
   "boxes": [
    [
     228.3,
     526.0,
     279.1,
     545.5
    ]
   ]
  },
  "q48_no": {
   "kind": "tick",
   "page": 20,
   "boxes": [
    [
     65.3,
     408.3,
     76.4,
     419.4
    ]
   ]
  },
  "q48_yes": {
   "kind": "tick",
   "page": 20,
   "boxes": [
    [
     65.3,
     426.7,
     76.4,
     437.8
    ]
   ]
  },
  "q48_1_type": {
   "kind": "text",
   "page": 20,
   "boxes": [
    [
     52.6,
     537.3,
     279.1,
     556.9
    ]
   ]
  },
  "q48_1_country": {
   "kind": "text",
   "page": 20,
   "boxes": [
    [
     52.6,
     574.1,
     279.1,
     593.7
    ]
   ]
  },
  "q48_1_amount": {
   "kind": "text",
   "page": 20,
   "boxes": [
    [
     52.6,
     622.6,
     162.9,
     642.2
    ]
   ]
  },
  "q49_no": {
   "kind": "tick",
   "page": 20,
   "boxes": [
    [
     348.8,
     354.5,
     359.9,
     365.5
    ]
   ]
  },
  "q49_yes": {
   "kind": "tick",
   "page": 20,
   "boxes": [
    [
     348.8,
     374.3,
     359.9,
     385.4
    ]
   ]
  },
  "q50_no": {
   "kind": "tick",
   "page": 21,
   "boxes": [
    [
     65.3,
     285.0,
     76.4,
     296.1
    ]
   ]
  },
  "q50_yes": {
   "kind": "tick",
   "page": 21,
   "boxes": [
    [
     65.3,
     303.4,
     76.4,
     314.5
    ]
   ]
  },
  "q52_no": {
   "kind": "tick",
   "page": 21,
   "boxes": [
    [
     348.8,
     234.0,
     359.9,
     245.1
    ]
   ]
  },
  "q52_yes": {
   "kind": "tick",
   "page": 21,
   "boxes": [
    [
     348.8,
     252.4,
     359.9,
     263.5
    ]
   ]
  },
  "q53_no": {
   "kind": "tick",
   "page": 22,
   "boxes": [
    [
     65.3,
     275.1,
     76.4,
     286.2
    ]
   ]
  },
  "q53_yes": {
   "kind": "tick",
   "page": 22,
   "boxes": [
    [
     65.3,
     293.5,
     76.4,
     304.6
    ]
   ]
  },
  "q53_1_type": {
   "kind": "text",
   "page": 22,
   "boxes": [
    [
     52.6,
     378.6,
     279.1,
     398.1
    ]
   ]
  },
  "q53_1_gross": {
   "kind": "text",
   "page": 22,
   "boxes": [
    [
     52.6,
     415.4,
     279.1,
     435.0
    ]
   ],
   "padLeft": 12.7,
   "perAt": 128.6
  },
  "q53_2_type": {
   "kind": "text",
   "page": 22,
   "boxes": [
    [
     52.6,
     513.2,
     279.1,
     532.8
    ]
   ]
  },
  "q53_2_gross": {
   "kind": "text",
   "page": 22,
   "boxes": [
    [
     52.6,
     550.0,
     279.1,
     569.6
    ]
   ],
   "padLeft": 12.7,
   "perAt": 128.6
  },
  "q56_no": {
   "kind": "tick",
   "page": 23,
   "boxes": [
    [
     65.3,
     266.6,
     76.4,
     277.7
    ]
   ]
  },
  "q56_yes": {
   "kind": "tick",
   "page": 23,
   "boxes": [
    [
     65.3,
     286.4,
     76.4,
     297.5
    ]
   ]
  },
  "q56_1_description": {
   "kind": "text",
   "page": 23,
   "boxes": [
    [
     52.4,
     353.0,
     278.9,
     372.6
    ]
   ]
  },
  "q56_1_value": {
   "kind": "text",
   "page": 23,
   "boxes": [
    [
     52.5,
     389.9,
     162.8,
     409.5
    ]
   ]
  },
  "q56_1_share_you": {
   "kind": "text",
   "page": 23,
   "boxes": [
    [
     166.0,
     438.0,
     218.1,
     457.5
    ]
   ]
  },
  "q56_1_share_partner": {
   "kind": "text",
   "page": 23,
   "boxes": [
    [
     221.9,
     438.0,
     278.2,
     457.5
    ]
   ]
  },
  "q56_2_description": {
   "kind": "text",
   "page": 23,
   "boxes": [
    [
     52.4,
     484.8,
     278.9,
     504.4
    ]
   ]
  },
  "q56_2_value": {
   "kind": "text",
   "page": 23,
   "boxes": [
    [
     52.5,
     521.7,
     162.8,
     541.3
    ]
   ]
  },
  "q56_2_share_you": {
   "kind": "text",
   "page": 23,
   "boxes": [
    [
     166.0,
     569.8,
     218.1,
     589.4
    ]
   ]
  },
  "q56_2_share_partner": {
   "kind": "text",
   "page": 23,
   "boxes": [
    [
     221.9,
     569.8,
     278.2,
     589.4
    ]
   ]
  }
 }
}